import React from "react";
import { IonCol, IonRow } from "@ionic/react";
import BasicModal from "./BasicModal";

interface DeleteConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    /** Primary question shown in the body. Defaults to "Are you sure?" */
    message?: string;
    /** Danger-colored warning under the message */
    warningMessage?: string;
    /** Simple underlined item label when no custom children are provided */
    itemName?: string;
    /** Custom body content (e.g. an entry info card). Takes precedence over itemName. */
    children?: React.ReactNode;
    isLoading?: boolean;
    errorMessage?: string;
    confirmText?: string;
    loadingText?: string;
    cancelText?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message = "Are you sure?",
    warningMessage = "This action cannot be undone.",
    itemName,
    children,
    isLoading = false,
    errorMessage,
    confirmText = "Delete",
    loadingText = "Deleting...",
    cancelText = "Cancel",
}) => {
    return (
        <BasicModal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            isLoading={isLoading}
            errorMessage={errorMessage}
            footerButtons={[
                {
                    text: cancelText,
                    color: "light",
                    disabled: isLoading,
                    onClick: onClose,
                },
                {
                    text: confirmText,
                    loadingText,
                    color: "danger",
                    disabled: isLoading,
                    onClick: onConfirm,
                },
            ]}>
            <>
                <IonRow className="ion-justify-content-center mb-0">
                    <IonCol className="ion-text-center pb-0">
                        <h2 className="text-info font-weight-bold mb-0">{message}</h2>
                    </IonCol>
                </IonRow>
                <IonRow className="ion-justify-content-center mt-0">
                    <IonCol className="ion-text-center pt-0">
                        <h5 className="text-danger font-weight-bold mt-0">{warningMessage}</h5>
                    </IonCol>
                </IonRow>
                {(children || itemName) && (
                    <IonRow className="ion-justify-content-center">
                        <IonCol sizeXs="12" sizeMd="10">
                            {children ? (
                                children
                            ) : (
                                <h4 className="ion-text-center border-bottom border-info">{itemName}</h4>
                            )}
                        </IonCol>
                    </IonRow>
                )}
            </>
        </BasicModal>
    );
};

export default DeleteConfirmationModal;
